import type { IStatusPanelParams } from 'ag-grid-community'
import type { ReactElement } from 'react'

import Button from '~/components/Buttons/Button'
import { LOCAL_STORAGE } from '~/const'
import { throttle } from '~/utils/function'
import { displayToast } from '~/utils/toast'

import './styles.scss'

const fieldsToExclude = [
  'app_key',
  'country',
  'date',
  'device_type',
  'month',
  'ua_adset_name',
  'ua_campaign_name',
  'ua_source',
  'week',
]

const SettingsComponent = ({ api }: IStatusPanelParams): ReactElement => {
  const handleSaveColumnConfig = throttle(() => {
    const columnDefs =
      api
        .getColumnDefs()
        ?.filter((colDef) => !('field' in colDef && !!colDef.field && fieldsToExclude.includes(colDef.field))) || []

    localStorage.setItem(LOCAL_STORAGE.UA_DASHBOARD_COLUMNS, JSON.stringify(columnDefs))
    displayToast('Table settings saved', 'success')
  }, 1000)

  const resizeColumns = () => api.autoSizeAllColumns()

  return (
    <div className="ua-dashboard-settings-component">
      <Button onClick={handleSaveColumnConfig} outlined size="small">
        Save table settings
      </Button>
      <Button onClick={resizeColumns} outlined size="small">
        Resize columns
      </Button>
    </div>
  )
}

export default SettingsComponent
